import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MAIN_BG = {
  backgroundColor: '#0a0e1c',
  backgroundImage:
    // Тёмная вуаль + перелив синий → малиновый + картинка
    "linear-gradient(180deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.45) 100%), " +
    "linear-gradient(90deg, rgba(10,16,38,0.65) 0%, rgba(12,28,42,0.58) 30%, rgba(14,46,56,0.55) 55%, rgba(16,72,70,0.6) 80%, rgba(22,108,90,0.65) 100%), " +
    "url('/hd_7bb30c833d2578b47e6367e472d210e3.jpeg')",
  backgroundSize: 'cover, cover, cover',
  backgroundPosition: 'center, center, center',
  backgroundAttachment: 'fixed, fixed, fixed',
  minHeight: '100vh',
};

const ADMIN_BG = {
  background: 'linear-gradient(180deg, #0f1419 0%, #1a1f2e 50%, #0d1117 100%)',
  minHeight: '100vh',
};

function applyMainBg() {
  document.body.style.backgroundColor = MAIN_BG.backgroundColor;
  document.body.style.backgroundImage = MAIN_BG.backgroundImage;
  document.body.style.backgroundSize = MAIN_BG.backgroundSize;
  document.body.style.backgroundPosition = MAIN_BG.backgroundPosition;
  document.body.style.backgroundAttachment = MAIN_BG.backgroundAttachment;
  document.body.style.backgroundRepeat = 'no-repeat';
  document.body.style.minHeight = MAIN_BG.minHeight;
}

function applyAdminBg() {
  document.body.style.background = ADMIN_BG.background;
  document.body.style.minHeight = ADMIN_BG.minHeight;
  document.body.style.backgroundImage = 'none';
  document.body.style.backgroundSize = '';
  document.body.style.backgroundPosition = '';
  document.body.style.backgroundAttachment = '';
  document.body.style.backgroundColor = '';
}

/**
 * Синхронизирует фон body с маршрутом. Один раз смонтирован в App — не размонтируется при навигации.
 * Только обновляет стили при смене pathname, без cleanup который очищает фон (избегаем мерцания и поломки).
 */
export default function BodyBackgroundSync() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/wiki/admin')) {
      applyAdminBg();
    } else {
      applyMainBg();
    }
    return () => {
      applyMainBg();
    };
  }, [pathname]);

  return null;
}
